import React from "react";

/**
 * Wordmark — text-based brand identity for the site header.
 * Uses the brand serif (Cormorant Garamond) with a gold devanagari-inspired
 * bindi flourish to maintain the heritage-FMCG feel.
 */
const Wordmark = ({ inverted = false }) => {
  const primary = inverted ? "#FBF6EC" : "#3B2A1A";
  const accent = "#C89D3C";
  const muted = inverted ? "#E2C37B" : "#8A6E4B";

  return (
    <div className="flex flex-col leading-none" data-testid="brand-wordmark">
      <div className="flex items-baseline gap-1.5">
        <span
          className="font-serif tracking-[0.02em] text-[26px] sm:text-[32px] font-medium"
          style={{ color: primary, fontFamily: "'Cormorant Garamond', serif" }}
        >
          Sanatan
        </span>
        <span
          aria-hidden="true"
          className="inline-block w-1.5 h-1.5 rounded-full"
          style={{ backgroundColor: accent }}
        />
        <span
          className="font-serif tracking-[0.02em] text-[26px] sm:text-[32px] font-medium"
          style={{ color: primary, fontFamily: "'Cormorant Garamond', serif" }}
        >
          Dharma
        </span>
        <sup
          className="text-[9px] sm:text-[10px] ml-0.5"
          style={{ color: accent }}
        >
          ™
        </sup>
      </div>
      <span
        className="mt-1 text-[9px] sm:text-[10px] uppercase tracking-[0.28em] font-semibold"
        style={{ color: muted }}
      >
        Har Ghar Ka Vishwas
      </span>
    </div>
  );
};

export default Wordmark;
